import {
  $create,
  DOMConversionMap,
  DOMConversionOutput,
  DOMExportOutput,
  ElementNode,
  LexicalEditor,
  LexicalNode,
} from 'lexical';
import { exportChildrenToDOM } from '../utils/exportNodesToDOM';
import { cleanTableHTML } from '../utils/cleanTableHTML';

export class HtmlNode extends ElementNode {
  $config() {
    return this.config('html', {});
  }

  static importDOM(): DOMConversionMap | null {
    return {
      div: () => ({
        conversion: (): DOMConversionOutput => {
          const node = $createHtmlNode();
          return { node };
        },
        priority: 0,
      }),
    };
  }

  createDOM(): HTMLElement {
    const container = document.createElement('div');
    return container;
  }

  updateDOM(): boolean {
    return false;
  }

  exportDOM(editor: LexicalEditor): DOMExportOutput {
    const container = document.createElement('div');
    exportChildrenToDOM(this, container, editor);
    cleanTableHTML(container);
    return { element: container };
  }
}

export function $createHtmlNode(): HtmlNode {
  return $create(HtmlNode);
}

export function $isHtmlNode(node: LexicalNode | null | undefined): node is HtmlNode {
  return node instanceof HtmlNode;
}
